// extracted by mini-css-extract-plugin
export default {"permSetForm":"permSetForm---xMwIn"};